import Vue from 'vue'
import define from '../systemAdminDefineModules/systemAdminDefineMutation.js'
// notifications-action
const URL = process.env.API_MASTER_URL
const header = define.state.header

export default {
  inputVersion(store, payload) {
    store.commit('inputVersion', payload)
  },

  async setVersion(store, payload) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {}
    }
    const response = await Vue.http.post(
      URL + '/v2/master/version/detail',
      data,
      config
    )

    // 成功後の処理
    store.commit('setVersion', response)
  },

  async updateVersion(store, payload) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        version: payload.versionIOS,
        os: 1 // iOS
      }
    }
    const response = await Vue.http.post(
      URL + '/v2/master/version/update',
      data,
      config
    )

    // 成功後の処理
    store.commit('setVersion', response)
  }
}



// WEBPACK FOOTER //
// ./src/store/systemAdminModules/forcedUpdateModules/actions.js